/**
 * Dependencies.
 */
import { setupI18n } from '@prz-dp/services';
import { UI_I18N_MESSAGES } from '@prz-dp/ui-next';

import DOCUMENT_I18N from '@/modules/document/i18n';
import EVALUATION_I18N from '@/modules/evaluation/i18n';
import MAIN_I18N from '@/modules/main/i18n';
import SERVICE_POINT from '@/modules/service-point/i18n';
import SURVEY_I18N from '@/modules/survey/i18n';
import TRACKING_OLD_I18N from '@/modules/tracking-old/i18n';
import TRACKING_I18N from '@/modules/tracking/i18n';

/**
 * Constant `numberFormatsConfig`.
 */
const numberFormatsConfig = {
  BRL: {
    currency: 'BRL',
    style: 'currency'
  },
  EUR: {
    currency: 'EUR',
    style: 'currency'
  },
  USD: {
    currency: 'USD',
    style: 'currency'
  }
};

/**
 * Export `setupI18n`.
 */
export const i18n = setupI18n(
  [
    MAIN_I18N,
    DOCUMENT_I18N,
    EVALUATION_I18N,
    SERVICE_POINT,
    SURVEY_I18N,
    TRACKING_I18N,
    TRACKING_OLD_I18N,
    UI_I18N_MESSAGES
  ],
  {
    'de-DE': numberFormatsConfig,
    'en-US': numberFormatsConfig,
    'es-ES': numberFormatsConfig,
    'it-IT': numberFormatsConfig,
    'pt-PT': numberFormatsConfig
  }
);
